import React from 'react';
import Paragraph from '../typography/Paragraph';
import Heading from '../typography/Heading';

interface AboutSectionProps {
  title: string;
  description: string;
  image: string;
  reverse?: boolean; // for Vision section
}

const AboutSection: React.FC<AboutSectionProps> = ({
  title,
  description,
  image,
  reverse = false,
}) => {
  return (
    <section className="w-full">
      <div className="container mx-auto pt-8 md:pt-20 py-6 px-5 lg:px-0">
        <div
          className={`grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-8 items-center ${
            reverse
              ? 'lg:[&>*:first-child]:order-2 lg:[&>*:last-child]:order-1'
              : ''
          }`}
        >
          <div className="flex flex-col justify-center">
            <Heading>{title}</Heading>
            <Paragraph>{description}</Paragraph>
          </div>
          <div className="rounded-3xl h-[400px] lg:h-[500px] overflow-hidden">
            <img
              src={image}
              alt={title}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
